export default __webpack_public_path__ + "static/media/DDD-Partners.6d2b2500.png";